// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@turnerBlueprint/Overrides/Widgets/ProductList/ProductListCardList";
import { color, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

listStyles.wrapper = {
    css: css`
        ${({ view }: any) =>
            view === "Grid"
                ? css`
                      border-bottom: 1px solid ${color("common.border")};
                      padding-top: 8px;
                  `
                : ""};
    `,
};

listStyles.cardContainerStyles = {
    cardDivider: {
        css: css`
            margin: 0;
            width: 100%;
            ${xScreen("lte", "md")} {
                width: 50%;
                padding-right: 10px;
                &:nth-child(2n) {
                    padding-left: 10px;
                    padding-right: 0;
                }
            }
            ${xScreen("lt", "sm")} {
                width: 100%;
                padding: 0;
                &:nth-child(2n) {
                    padding-left: 0;
                }
            }
        `,
    },
    gridItem: {
        css: css`
            ${xScreen("lte", "md")} {
                height: 100%;
            }
        `,
    },
};

listStyles.cardContainerMultiColumnStyles = {
    cardDivider: {
        css: css`
            border-bottom: none;
            padding: 2px 11px;
        `,
    },
};
